import React from "react";
import styles from "./index.module.scss";
import PropTypes from "prop-types";
import { XTabNav } from "@/components/xqxc_ui";
import LanguagePack from "../languagePack"; //提醒设置
import ApplyReason from "../applyReason"; //申诉理由配置
import Complaint from "../complaint"; //投诉原因配置
import Riskcontrol from "../riskcontrol"; //限制配置
import Riskparams from "../riskparams"; //限制参数配置
import AbnormalType from "../abnormalType"; //异常类型配置
import CancelReason from "../cancelReason"; //取消原因配置
import PunishReason from "../punishReason"; //惩罚原因配置
import Insuranceset from "../insuranceset"; //保险设置
import RiderInsuranceConfig from "../riderInsuranceConfig"; //骑手投保配置
import { getLocalStorage } from "@/assets/js/storage";

class Main extends React.Component {
  state = {
    tab: [
      { id: 1, label: "提醒设置", url: "system/parameter/txsz" },
      { id: 2, label: "限制配置", url: "system/parameter/xzpz" },
      { id: 3, label: "限制参数", url: "system/parameter/xzcs" },
      { id: 4, label: "投诉原因配置", url: "system/parameter/tsyypz" },
      { id: 5, label: "申诉理由配置", url: "system/parameter/sslypz" },
      { id: 6, label: "异常类型配置", url: "system/parameter/yclxpz" },
      { id: 7, label: "取消原因配置", url: "system/parameter/qxyypz" },
      { id: 8, label: "惩罚原因配置", url: "system/parameter/cfyypz" },
      { id: 9, label: "保险设置", url: "system/parameter/bgbxsz" },
      { id: 10, label: "骑手投保配置", url: "system/parameter/qstbpz" },
    ],
    curTabID: 1, // 默认显示的tab
  };

  componentDidMount() {
    this.getBtnPermission();
  }

  getBtnPermission = () => {
    let btnPremission = JSON.parse(getLocalStorage('btnPremission')) || [];
    console.log("btnPremission ---- ", btnPremission);
    let list = [];
    this.state.tab.forEach(v => {
      btnPremission.forEach(item => {
        if (item.url == v.url && ['READ_WRITE', 'READ_ONLY'].includes(item.type)) {
          list.push(v);
        }
      });
    });
    let nextCurID = list[0] ? list[0].id : 0;
    const histTabID = this.props.history && this.props.history.location && this.props.history.location.state;
    if (histTabID && list.some(t => t.id == histTabID)) {
      nextCurID = histTabID;
    }
    this.setState({ tab: list, curTabID: nextCurID });
  };

  // Tab导航切换操作回调
  _tabChangeHandle = (tabID) => {
    this.setState({ curTabID: tabID });
  };

  // 渲染相应Tab导航下的内容
  _renderPage = () => {
    const { curTabID } = this.state;
    switch (curTabID) {
      case 1:
        return (
          <LanguagePack
            curTabID={this.state.curTabID}
            history={this.props.history}
            updateContent={this.props.updateContent}
          />
        );
      case 2:
        return (
          <Riskcontrol
            curTabID={this.state.curTabID}
            history={this.props.history}
            updateContent={this.props.updateContent}
          />
        );
      case 3:
        return (
          <Riskparams
            curTabID={this.state.curTabID}
            history={this.props.history}
            updateContent={this.props.updateContent}
          />
        );
      case 4:
        return (
          <Complaint
            curTabID={this.state.curTabID}
            history={this.props.history}
            updateContent={this.props.updateContent}
          />
        );
      case 5:
        return (
          <ApplyReason
            curTabID={this.state.curTabID}
            history={this.props.history}
            updateContent={this.props.updateContent}
          />
        );
      case 6:
        return (
          <AbnormalType
            curTabID={this.state.curTabID}
            history={this.props.history}
            updateContent={this.props.updateContent}
          />
        );
      case 7:
        return (
          <CancelReason
            curTabID={this.state.curTabID}
            history={this.props.history}
            updateContent={this.props.updateContent}
          />
        );
      case 8:
        return (
          <PunishReason
            curTabID={this.state.curTabID}
            history={this.props.history}
            updateContent={this.props.updateContent}
          />
        );
      case 9:
        return (
          <Insuranceset
            curTabID={this.state.curTabID}
            history={this.props.history}
            updateContent={this.props.updateContent}
          />
        );
      case 10:
        return (
          <RiderInsuranceConfig
            curTabID={this.state.curTabID}
            history={this.props.history}
            updateContent={this.props.updateContent}
          />
        );
      default:
        return null;
    }
  };

  render() {
    return (
      <div className={styles.flexBoxContainer}>
        <XTabNav
          renderData={this.state.tab}
          onChange={this._tabChangeHandle}
          activedID={this.state.curTabID}
        />
        <div className={styles.line}></div>
        <div className={styles.tableContainer}>{this._renderPage()}</div>
      </div>
    );
  }
}

Main.propTypes = {
  history: PropTypes.object, // 路由history对象
  updateContent: PropTypes.func, // 跳转其它路由页面
};

export default Main;
